import React from "react";
import { Container, ParagraphContainer } from "./ParagraphLayoutHelpers";
import { Constants } from "../../../@types/Constants";

const ParagraphLayout: React.FC<any> = (props) => {
  const _keys = Object.keys(props);
  const _paragraphs = _keys.map((key: any) => {
    return props[key];
  });

  return (
    <Container>
      {_paragraphs.map((p: any, i: number) => {
        let isSkip;
        if (p && p.props && "paragraphtype" in p.props) {
          isSkip = p.props.paragraphtype === Constants.PARAGRAPH_PAGE_BANNER;
        } else {
          isSkip = true;
        }
        if (isSkip) {
          return;
        }
        const _bgColor = i % 2 === 0 ? "alt" : "";
        return (
          <ParagraphContainer
            key={i}
            bgColor={_bgColor}
            isbelowSearchParagraphs={props.isbelowSearchParagraphs}
          >
            {p}
          </ParagraphContainer>
        );
      })}
    </Container>
  );
};

export default ParagraphLayout;
